import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07427de5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "categoryTag px-5 m-1"
}
const _hoisted_2 = {
  key: 1,
  class: "servingTag px-5 m-1"
}

import { Tag } from '@/features/partnerOffers/model';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferTag',
  props: {
    tag: null,
    type: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.type=='CATEGORY')
      ? (_openBlock(), _createElementBlock("button", _hoisted_1, _toDisplayString(__props.tag.name), 1))
      : _createCommentVNode("", true),
    (__props.type=='SERVING')
      ? (_openBlock(), _createElementBlock("button", _hoisted_2, _toDisplayString(__props.tag.name), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})